import MediaThumbnail from './Thumbnail/Thumbnail'
import Media from './Media'

export { MediaThumbnail }
export default Media
